import { priceFormat } from '~/shared/lib/utils'
import {
  AsyncGridColumns,
  ColumnLink,
  ColumnValue,
} from '~/shared/ui/AsyncGrid'
import { ChipStatus } from '~/shared/ui/Chips'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.vin',
    field: 'vin',
    sortable: false,
    minWidth: 260,
    renderCell: ({ row }) => (
      <ColumnLink to={`/cars/${row.id}/details`}>{row.vin}</ColumnLink>
    ),
  },
  {
    headerName: 'column.license plate number',
    field: 'plateNumber',
    sortable: false,
    minWidth: 160,
  },
  {
    headerName: 'column.region',
    field: 'region',
    sortable: false,
    minWidth: 160,
  },
  {
    headerName: 'column.subdivision',
    field: 'subdivision',
    sortable: false,
    minWidth: 200,
  },
  {
    headerName: 'column.model',
    field: 'model',
    sortable: false,
    minWidth: 160,
  },
  {
    headerName: 'column.status',
    field: 'status',
    sortable: false,
    minWidth: 160,
    renderCell: ({ value }) =>
      value && <ChipStatus label={value.label} variant={value.color} />,
  },
  {
    headerName: 'column.substatus',
    field: 'subStatus',
    sortable: false,
    minWidth: 160,
    renderCell: ({ value }) =>
      value && <ChipStatus label={value} variant='gray' />,
  },
  {
    headerName: 'column.buyout',
    field: 'isLeasingFullyPaid',
    sortable: false,
    minWidth: 70,
    renderCell: ({ value }) => (
      <ChipStatus
        labelI18n={value ? 'button.yes' : 'button.no'}
        variant={value ? 'yellow' : 'gray'}
      />
    ),
  },
  {
    headerName: 'column.participates in promotion',
    field: 'isPromotion',
    sortable: false,
    minWidth: 160,
    renderCell: ({ value }) => (
      <ChipStatus
        labelI18n={value ? 'button.yes' : 'button.no'}
        variant={value ? 'purple' : 'gray'}
      />
    ),
  },
  {
    headerName: 'column.pre total',
    field: 'isPreTotaled',
    sortable: false,
    minWidth: 120,
    renderCell: ({ value }) => (
      <ChipStatus
        labelI18n={value ? 'button.yes' : 'button.no'}
        variant={value ? 'red' : 'gray'}
      />
    ),
  },
  {
    headerName: 'column.type of ownership',
    field: 'propertyType',
    sortable: false,
    minWidth: 200,
  },
  {
    headerName: 'column.price per day',
    field: 'pricePerDay',
    sortable: false,
    minWidth: 160,
    renderCell: ({ value }) =>
      value != null && <ColumnValue>{priceFormat(value)}</ColumnValue>,
  },
  {
    headerName: 'column.dynamic price',
    field: 'isOwnPricePerDay',
    sortable: false,
    minWidth: 140,
    renderCell: ({ value }) => (
      <ChipStatus
        labelI18n={value ? 'button.yes' : 'button.no'}
        variant={value ? 'yellow' : 'gray'}
      />
    ),
  },
]
